// Arts et Métiers ("Gadzarts") campus codes used to build a promotion's
// name: campus code + entry year minus 1800 (e.g. Angers 2011 -> "An211").
//
// Each campus/center has its own traditional nickname and DaisyUI theme:
// Angers is "La Boquette" (the only one), Aix-en-Provence is "KIN" (from
// the "Cayenne" pronunciation, no apostrophe/s), every other active center
// is a "Tabagn's" — e.g. "Tabagn's de Chalons", "Tabagn's de Birse" (Lille)
// — except Bordeaux and Metz, which have their own distinct nicknames
// ("Bordel's", "Siber's"). The two historical/inactive centers (Karlsruhe,
// Paris) have no known traditional nickname, so they just go by their name.
export interface GadzartsCampus {
	code: string;
	name: string;
	nickname: string;
	theme: string;
	active: boolean;
}

export const GADZARTS_CAMPUSES: GadzartsCampus[] = [
	{ code: 'Ai', name: 'Aix-en-Provence', nickname: 'KIN', theme: 'kins', active: true },
	{ code: 'An', name: 'Angers', nickname: 'La Boquette', theme: 'boquette', active: true },
	{ code: 'Bo', name: 'Bordeaux-Talence', nickname: "Bordel's", theme: 'bordels', active: true },
	{ code: 'Ch', name: 'Châlons-en-Champagne', nickname: "Tabagn's de Chalons", theme: 'chalons', active: true },
	{ code: 'Cl', name: 'Cluny', nickname: "Clun's", theme: 'cluns', active: true },
	{ code: 'Li', name: 'Lille', nickname: "Tabagn's de Birse", theme: 'birse', active: true },
	{ code: 'Me', name: 'Metz', nickname: "Siber's", theme: 'sibers', active: true },
	{ code: 'Ka', name: 'Karlsruhe', nickname: 'Karlsruhe', theme: 'karlsruhe', active: false },
	{ code: 'Pa', name: 'Paris', nickname: 'Paris', theme: 'paris', active: false },
];

export function findCampusByCode(campusCode: string): GadzartsCampus | null {
	const normalizedCode = campusCode.trim().toLowerCase();
	return GADZARTS_CAMPUSES.find((campus) => campus.code.toLowerCase() === normalizedCode) ?? null;
}

/** Extracts the 2-letter campus code from a promotion string like "An211" or "Cl87". */
export function campusCodeFromPromotion(promotion: string): string | null {
	const match = /^([A-Za-z]{2})\d{2,3}$/.exec(promotion.trim());
	return match ? match[1] : null;
}

export function findCampusByPromotion(promotion: string): GadzartsCampus | null {
	const campusCode = campusCodeFromPromotion(promotion);
	return campusCode ? findCampusByCode(campusCode) : null;
}
